import React from "react";
import logo from "../../img/fanvision45.png";
import { Link, useNavigate } from "react-router-dom";
import { post } from "../../util";
import { GoogleLogin, googleLogout } from "@react-oauth/google";
import "./Nav.css";

const Nav = ({ user, updateUser }) => {
  const navigate = useNavigate();

  const handleLogin = (res) => {
    const token = res.credential;
    post("/api/login", { token }).then((user) => {
      updateUser(user?._id ? user : undefined);
      navigate("/");
    });
  };

  const handleLogout = () => {
    post("/api/logout").then(() => {
      updateUser(undefined);
      navigate("/");
    });
  };

  return (
    <nav className="Navbar-container flex flex-row justify-between items-center">
      <div className="flex flex-row items-center">
        <div
          className="Navbar-title flex flex-row items-center"
          onClick={() => navigate("/")}
        >
          <img src={logo} className="Navbar-logo mr2" alt="" />
          Fanvision
        </div>
        <div className="Navbar-routeContainer u-inlineBlock">
          {user ? (
            <Link
              to="/dashboard"
              className={
                window.location.pathname === "/dashboard"
                  ? "Navbar-route Route-clicked"
                  : "Navbar-route"
              }
            >
              Dashboard
            </Link>
          ) : (
            <div></div>
          )}
          {user ? (
            <Link
              to="/predictions"
              className={
                window.location.pathname === "/predictions"
                  ? "Navbar-route Route-clicked"
                  : "Navbar-route"
              }
            >
              Predict
            </Link>
          ) : (
            <div></div>
          )}
          {user ? (
            <Link
              to="/overallstandings"
              className={
                window.location.pathname === "/overallstandings"
                  ? "Navbar-route Route-clicked"
                  : "Navbar-route"
              }
            >
              Standings
            </Link>
          ) : (
            <div></div>
          )}
        </div>
      </div>

      <div className="flex flex-row items-center">
        {user ? (
          <div className="Navbar-rightside">
            <div className="u-inlineBlock Navbar-pfpContainer">
              <img src={user.picture} className="Navbar-pfp" alt="" />
            </div>
            <Link
              to={`/profile/${user._id}`}
              className="Navbar-name u-inlineBlock"
            >
              {user.name.split(" ")[0]}{" "}
            </Link>
          </div>
        ) : (
          <div />
        )}
        {user ? (
          <button
            onClick={() => {
              googleLogout();
              handleLogout();
            }}
            className="button-log"
          >
            Log Out
          </button>
        ) : (
          <GoogleLogin
            onSuccess={handleLogin}
            onError={() => console.log(`Login failed.`)}
          />
        )}
      </div>
    </nav>
  );
};

export default Nav;
